export default __webpack_public_path__ + "static/media/visa.5285cd59.png";